import { set, toggle } from '@/utils/vuex'

export default {
  setDrawer: set('drawer'),
  setPanel (state, panel) {
    if (state.config[panel]) {
      state.panel = state.config[panel].panel
    }
  },
  setTitle (state, data) {
    state.title = data.title
  },
  setSocketUrl (state, data) {
    state.socketUrl = data.socket_url
  },
  setSocketSid (state, data) {
    state.socketSid = data.socket_sid
  }
}
